import { SchemaTypes } from '@allesauto/graphql';
import { FieldTypeAsset, FieldTypeLink } from '@allesauto/utils/consts';
import { createContext, useContext } from 'react';

import { HeaderProps } from '../header';
import { LogoItem, WlNavigation } from '../whiteLabelHeader';

export type schneiderNav = {
  item: {
    title: string;
    route: string;
    children?: {
      item: {
        title: string;
        route: string;
      };
    };
  };
};

/**
 * Storyblok site configuration object (default props by Storyblok and custom props defined in Bloks)
 */
export interface StoryblokSiteConfig {
  logo: string;
  navigation: WlNavigation[];
  header_logo?: FieldTypeAsset;
  header_logo_link?: FieldTypeLink & { title?: string };
  header_make_logo: FieldTypeAsset;
  header_make_logo_link?: FieldTypeLink & { title?: string };
  footer_logo?: FieldTypeAsset;
  header_height?: string;
  header_layout?: string;
  LogoList?: LogoItem[];
  schneiderCustomNavigation?: schneiderNav;
  navigation_api_link?: FieldTypeLink;
  logo_width: string;
  logo_height: string;
  alternate_logo?: FieldTypeAsset;
  telephone_number?: string;
  company_name?: string;
  company_link?: FieldTypeLink;
  telephone_link?: FieldTypeLink;
  instagram_link?: FieldTypeLink;
  facebook_link?: FieldTypeLink;
  xing_link?: FieldTypeLink;
  youtube_link?: FieldTypeLink;
  logo_alt?: string;
  merchantOrigin?: string;
  menu_icon_logo?: FieldTypeAsset;
  whatsapp_link?: FieldTypeLink;
  email?: string;
  // And many other fields like social links, footer etc.
}

export interface StoryblokSiteConfigInitial {
  header: StoryblokSiteConfig;
  additionalHeaderProps?: HeaderProps;
  integrationSlug: string;
  // And many other fields like social links, footer etc.
}

type Query = Pick<SchemaTypes.Query, 'getWhiteLabelConfig'>;

export type WhiteLabelConfig = Omit<
  NonNullable<Query['getWhiteLabelConfig']>,
  'storyBlokResponse'
> & { storyBlokResponse?: any };

export const whiteLabelContext = createContext<WhiteLabelConfig | undefined>(
  undefined
);

export const useWhiteLabel = () => useContext(whiteLabelContext);
